import { useEffect, useState } from 'react';
import { GlobalSpinner } from '@eo/shared';

import { isSigningOut } from '../auth/signOutState';

const SPLASH_ANIMATION_SPEED = 0.9; // 4.17s native loop → ~4.6s slowed

// Branded loop shown while the boot chain settles. The hint only appears past
// the normal hold (a genuinely stalled boot); dev logs a warning after 12s.
export function BootSplash() {
  const [hint, setHint] = useState(false);
  // Read once: the pre-paint script has already resolved the theme, and the
  // splash is too short-lived to be worth observing class changes.
  const [isDark] = useState(
    () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    const t = setTimeout(() => setHint(true), 8_000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const t = setTimeout(() => console.warn('[BootSplash] still loading after 12s'), 12_000);
    return () => clearTimeout(t);
  }, []);

  // Sign-out is a teardown, not a boot — hold a quiet blank screen until the
  // browser leaves for Auth0 instead of flashing the brand loader.
  if (isSigningOut()) {
    return <div className="h-screen w-screen bg-background" />;
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-8 bg-background text-text-primary">
      <GlobalSpinner size={200} theme={isDark ? 'dark' : 'light'} speed={SPLASH_ANIMATION_SPEED} />
      <p className="text-sm text-text-tertiary">Mission Control</p>
      {hint && <div className="text-xs text-text-tertiary/70">Still loading…</div>}
    </div>
  );
}
